// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.backend-manager-container {
  padding: 1rem;
  height: calc(100% - 32px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  gap: 1rem;
  color: var(--text-secondary);
}

.error-message {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem;
  background: var(--error-bg, rgba(244, 67, 54, 0.1));
  border-radius: 8px;
  color: var(--error-color, #f44336);
  margin-bottom: 1rem;
}
.error-message mat-icon {
  flex-shrink: 0;
}
.error-message span {
  flex: 1;
}

h2 {
  margin: 0 0 0.5rem 0;
  font-size: 1.25rem;
  font-weight: 500;
}

.subtitle {
  color: var(--text-secondary);
  margin: 0 0 1.5rem 0;
}

.backend-list {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: rgba(155, 155, 155, 0.7) transparent;
}
.backend-list::-webkit-scrollbar {
  width: 8px;
}
.backend-list::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 4px;
}
.backend-list::-webkit-scrollbar-thumb {
  background: rgba(155, 155, 155, 0.7);
  border-radius: 4px;
}
.backend-list::-webkit-scrollbar-thumb:hover {
  background: rgba(175, 175, 175, 0.9);
}
.backend-list .backend-cards {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-bottom: 1rem;
}

.backend-card {
  background: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 1rem;
  cursor: pointer;
  transition: all 0.2s ease;
}
.backend-card:hover {
  border-color: var(--accent-color);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.backend-card.configured {
  border-left: 3px solid var(--success-color, #4caf50);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.backend-card .backend-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}
.backend-card .backend-name {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
  font-size: 1rem;
}
.backend-card .backend-name mat-icon {
  color: var(--accent-color);
}
.backend-card .status-badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
}
.backend-card .status-badge.status-ready {
  background: var(--success-bg, rgba(76, 175, 80, 0.1));
  color: var(--success-color, #4caf50);
}
.backend-card .status-badge.status-not-configured {
  background: var(--neutral-bg, rgba(158, 158, 158, 0.1));
  color: var(--text-secondary);
}
.backend-card .backend-description {
  color: var(--text-secondary);
  font-size: 0.875rem;
  margin: 0 0 1rem 0;
  line-height: 1.4;
}
.backend-card .backend-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.backend-card .backend-footer .model-count {
  font-size: 0.75rem;
  color: var(--text-secondary);
  margin-right: auto;
}
.backend-card .backend-footer .view-button {
  color: var(--text-primary);
  border-color: var(--border-color);
  background: transparent;
}
.backend-card .backend-footer .view-button:hover {
  background: var(--hover-bg, rgba(128, 128, 128, 0.1));
  border-color: var(--text-secondary);
}

.configure-view {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
}
.configure-view .configure-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--border-color);
  margin-bottom: 1rem;
  flex-shrink: 0;
}
.configure-view .configure-header h2 {
  margin: 0;
}
.configure-view .configure-content {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: rgba(155, 155, 155, 0.7) transparent;
  padding-bottom: 1rem;
}
.configure-view .configure-content::-webkit-scrollbar {
  width: 8px;
}
.configure-view .configure-content::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 4px;
}
.configure-view .configure-content::-webkit-scrollbar-thumb {
  background: rgba(155, 155, 155, 0.7);
  border-radius: 4px;
}
.configure-view .configure-content::-webkit-scrollbar-thumb:hover {
  background: rgba(175, 175, 175, 0.9);
}
.configure-view .backend-description {
  color: var(--text-secondary);
  margin-bottom: 1.5rem;
}

.status-section {
  background: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1.5rem;
}
.status-section h3 {
  margin: 0 0 1rem 0;
  font-size: 1rem;
  font-weight: 500;
}
.status-section .status-row {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
}
.status-section .status-row .status-label {
  color: var(--text-secondary);
  min-width: 120px;
}
.status-section .status-row .status-loading-value {
  color: var(--text-secondary);
  font-style: italic;
}
.status-section .status-row .status-ok {
  color: var(--success-color, #4caf50);
}
.status-section .status-row .status-warning {
  color: var(--warning-color, #ff9800);
}
.status-section button {
  margin-top: 1rem;
}

.config-section {
  background: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1.5rem;
}
.config-section h3 {
  margin: 0 0 0.5rem 0;
  font-size: 1rem;
  font-weight: 500;
}
.config-section p {
  color: var(--text-secondary);
  font-size: 0.875rem;
  margin: 0 0 1rem 0;
}
.config-section .full-width {
  width: 100%;
  margin-bottom: 1rem;
}
.config-section .get-key-button {
  margin-bottom: 1rem;
}
.config-section .get-key-button mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  margin-right: 0.5rem;
}

.cli-instructions .cli-buttons {
  display: flex;
  gap: 0.75rem;
  margin-top: 1rem;
  flex-wrap: wrap;
}
.cli-instructions .cli-buttons button mat-icon {
  margin-right: 0.5rem;
}

.cli-output {
  background: var(--code-bg, #1e1e1e);
  border-radius: 8px;
  padding: 1rem;
  overflow-x: auto;
}
.cli-output pre {
  margin: 0;
  font-family: "Fira Code", "Consolas", monospace;
  font-size: 0.8rem;
  line-height: 1.5;
  color: var(--code-text, #d4d4d4);
  white-space: pre-wrap;
  word-break: break-word;
}

.models-section {
  background: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 1rem;
}
.models-section h3 {
  margin: 0 0 0.5rem 0;
  font-size: 1rem;
  font-weight: 500;
}
.models-section .model-hint {
  color: var(--text-secondary);
  font-size: 0.875rem;
  margin: 0 0 1rem 0;
}
.models-section .full-width {
  width: 100%;
  margin-bottom: 0.5rem;
}
.models-section .save-model-button {
  margin-top: 0.5rem;
}
.models-section .model-chips mat-chip {
  font-size: 0.75rem;
}

button mat-spinner {
  display: inline-block;
  margin-right: 0.5rem;
}

.auth-loading {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem;
  color: var(--text-secondary);
}
.auth-loading mat-spinner {
  flex-shrink: 0;
}

.auth-prompt .auth-description {
  color: var(--text-secondary);
  margin-bottom: 1rem;
  line-height: 1.5;
}
.auth-prompt .auth-error {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: var(--error-bg, rgba(244, 67, 54, 0.1));
  border-radius: 8px;
  color: var(--error-color, #f44336);
  margin-bottom: 1rem;
  font-size: 0.875rem;
}
.auth-prompt .auth-error mat-icon {
  flex-shrink: 0;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.auth-prompt .auth-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
}
.auth-prompt .auth-button mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.auth-prompt .auth-note {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 1rem;
  color: var(--text-secondary);
  font-size: 0.8rem;
}
.auth-prompt .auth-note mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  opacity: 0.7;
}

.auth-progress .auth-starting {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem 1rem;
  text-align: center;
}
.auth-progress .auth-starting .auth-status-text {
  margin: 1rem 0 0.5rem;
  font-size: 1rem;
  color: var(--text-primary);
}
.auth-progress .auth-waiting {
  padding: 1rem 0;
}
.auth-progress .auth-waiting .auth-instructions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin: 0 0 0.75rem 0;
  font-size: 0.9rem;
  color: var(--text-primary);
}
.auth-progress .auth-waiting .auth-instructions mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: var(--success-color, #4caf50);
}
.auth-progress .auth-waiting .auth-code-field {
  margin-top: 1rem;
}
.auth-progress .auth-waiting .auth-error {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: var(--error-bg, rgba(244, 67, 54, 0.1));
  border-radius: 8px;
  color: var(--error-color, #f44336);
  margin-bottom: 1rem;
  font-size: 0.875rem;
}
.auth-progress .auth-waiting .auth-error mat-icon {
  flex-shrink: 0;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.auth-progress .auth-waiting .auth-actions {
  display: flex;
  gap: 0.75rem;
  margin-top: 1rem;
}
.auth-progress .auth-waiting .auth-actions button mat-spinner {
  margin-right: 0.5rem;
}

.auth-success {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem;
  background: var(--success-bg, rgba(76, 175, 80, 0.1));
  border-radius: 8px;
  color: var(--success-color, #4caf50);
  margin-bottom: 1rem;
}
.auth-success .success-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}

.auth-expired {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem;
  background: var(--error-bg, rgba(244, 67, 54, 0.1));
  border-radius: 8px;
  color: var(--error-color, #f44336);
  margin-bottom: 1rem;
}
.auth-expired .expired-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}

.token-details {
  background: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  font-size: 0.8rem;
}
.token-details .token-detail-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}
.token-details .token-detail-row:last-child {
  margin-bottom: 0;
}
.token-details .token-detail-row .detail-label {
  color: var(--text-secondary);
  min-width: 60px;
}
.token-details .token-detail-row .detail-value {
  color: var(--text-primary);
}
.token-details .token-detail-row .detail-value.expiring-soon {
  color: var(--warning-color, #ff9800);
}
.token-details .token-detail-row .detail-value.scopes {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
}
.token-details .token-detail-row .scope-chip {
  background: var(--neutral-bg, rgba(128, 128, 128, 0.15));
  padding: 0.15rem 0.5rem;
  border-radius: 4px;
  font-family: "Fira Code", "Consolas", monospace;
  font-size: 0.7rem;
}

.advanced-option {
  margin-top: 1.5rem;
}
.advanced-option mat-expansion-panel {
  background: transparent;
  box-shadow: none;
  border: 1px solid var(--border-color);
}
.advanced-option mat-expansion-panel mat-expansion-panel-header {
  font-size: 0.875rem;
  color: var(--text-secondary);
}`, "",{"version":3,"sources":["webpack://./src/app/components/strategy-grid/backend-manager-widget/backend-manager-widget.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,SAAA;EACA,4BAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,mDAAA;EACA,kBAAA;EACA,kCAAA;EACA,mBAAA;AACF;AACE;EACE,cAAA;AACJ;AAEE;EACE,OAAA;AAAJ;;AAIA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;AADF;;AAIA;EACE,4BAAA;EACA,oBAAA;AADF;;AAiCA;EA3BE,OAAA;EACA,gBAAA;EACA,kBAAA;EAEA,qBAAA;EACA,qDAAA;AAHF;AAKE;EACE,UAAA;AAHJ;AAME;EACE,uBAAA;EACA,kBAAA;AAJJ;AAOE;EACE,oCAAA;EACA,kBAAA;AALJ;AAOI;EACE,oCAAA;AALN;AAcE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,oBAAA;AAZJ;;AAgBA;EACE,0BAAA;EACA,qCAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,yBAAA;AAbF;AAeE;EACE,iCAAA;EACA,wCAAA;AAbJ;AAgBE;EACE,oDAAA;EACA,yBAAA;EACA,4BAAA;AAdJ;AAiBE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;AAfJ;AAkBE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AAhBJ;AAkBI;EACE,0BAAA;AAhBN;AAoBE;EACE,kBAAA;EACA,uBAAA;EACA,kBAAA;AAlBJ;AAoBI;EACE,qDAAA;EACA,oCAAA;AAlBN;AAqBI;EACE,uDAAA;EACA,4BAAA;AAnBN;AAuBE;EACE,4BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AArBJ;AAwBE;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;AAtBJ;AAwBI;EACE,kBAAA;EACA,4BAAA;EACA,kBAAA;AAtBN;AA0BI;EACE,0BAAA;EACA,iCAAA;EACA,uBAAA;AAxBN;AA0BM;EACE,qDAAA;EACA,mCAAA;AAxBR;;AA+BA;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,gBAAA;AA5BF;AA8BE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,4CAAA;EACA,mBAAA;EACA,cAAA;AA5BJ;AA8BI;EACE,SAAA;AA5BN;AAgCE;EAjJA,OAAA;EACA,gBAAA;EACA,kBAAA;EAEA,qBAAA;EACA,qDAAA;EA8IE,oBAAA;AA1BJ;AAlHE;EACE,UAAA;AAoHJ;AAjHE;EACE,uBAAA;EACA,kBAAA;AAmHJ;AAhHE;EACE,oCAAA;EACA,kBAAA;AAkHJ;AAhHI;EACE,oCAAA;AAkHN;AAeE;EACE,4BAAA;EACA,qBAAA;AAbJ;;AAiBA;EACE,0BAAA;EACA,qCAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;AAdF;AAgBE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;AAdJ;AAiBE;EACE,aAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;AAfJ;AAiBI;EACE,4BAAA;EACA,gBAAA;AAfN;AAkBI;EACE,4BAAA;EACA,kBAAA;AAhBN;AAmBI;EACE,oCAAA;AAjBN;AAoBI;EACE,oCAAA;AAlBN;AAsBE;EACE,gBAAA;AApBJ;;AAwBA;EACE,0BAAA;EACA,qCAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;AArBF;AAuBE;EACE,oBAAA;EACA,eAAA;EACA,gBAAA;AArBJ;AAwBE;EACE,4BAAA;EACA,mBAAA;EACA,kBAAA;AAtBJ;AAyBE;EACE,WAAA;EACA,mBAAA;AAvBJ;AA0BE;EACE,mBAAA;AAxBJ;AA0BI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;AAxBN;;AA8BE;EACE,aAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AA3BJ;AA6BI;EACE,oBAAA;AA3BN;;AAgCA;EACE,mCAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AA7BF;AA+BE;EACE,SAAA;EACA,+CAAA;EACA,iBAAA;EACA,gBAAA;EACA,gCAAA;EACA,qBAAA;EACA,sBAAA;AA7BJ;;AAiCA;EACE,0BAAA;EACA,qCAAA;EACA,kBAAA;EACA,aAAA;AA9BF;AAgCE;EACE,oBAAA;EACA,eAAA;EACA,gBAAA;AA9BJ;AAiCE;EACE,4BAAA;EACA,mBAAA;EACA,kBAAA;AA/BJ;AAkCE;EACE,WAAA;EACA,qBAAA;AAhCJ;AAmCE;EACE,kBAAA;AAjCJ;AAqCI;EACE,kBAAA;AAnCN;;AA0CE;EACE,qBAAA;EACA,oBAAA;AAvCJ;;AA4CA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,4BAAA;AAzCF;AA2CE;EACE,cAAA;AAzCJ;;AA8CE;EACE,4BAAA;EACA,mBAAA;EACA,gBAAA;AA3CJ;AA8CE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,mDAAA;EACA,kBAAA;EACA,kCAAA;EACA,mBAAA;EACA,mBAAA;AA5CJ;AA8CI;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AA5CN;AAgDE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,eAAA;AA9CJ;AAgDI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA9CN;AAkDE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,4BAAA;EACA,iBAAA;AAhDJ;AAkDI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAhDN;;AAsDE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAnDJ;AAqDI;EACE,qBAAA;EACA,eAAA;EACA,0BAAA;AAnDN;AAuDE;EACE,eAAA;AArDJ;AAuDI;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,0BAAA;AArDN;AAuDM;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;AArDR;AAyDI;EACE,gBAAA;AAvDN;AA0DI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,mDAAA;EACA,kBAAA;EACA,kCAAA;EACA,mBAAA;EACA,mBAAA;AAxDN;AA0DM;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAxDR;AA4DI;EACE,aAAA;EACA,YAAA;EACA,gBAAA;AA1DN;AA4DM;EACE,oBAAA;AA1DR;;AAgEA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,qDAAA;EACA,kBAAA;EACA,oCAAA;EACA,mBAAA;AA7DF;AA+DE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA7DJ;;AAiEA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,mDAAA;EACA,kBAAA;EACA,kCAAA;EACA,mBAAA;AA9DF;AAgEE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA9DJ;;AAkEA;EACE,0BAAA;EACA,qCAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;AA/DF;AAiEE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;AA/DJ;AAiEI;EACE,gBAAA;AA/DN;AAkEI;EACE,4BAAA;EACA,eAAA;AAhEN;AAmEI;EACE,0BAAA;AAjEN;AAmEM;EACE,oCAAA;AAjER;AAoEM;EACE,aAAA;EACA,eAAA;EACA,YAAA;AAlER;AAsEI;EACE,wDAAA;EACA,uBAAA;EACA,kBAAA;EACA,+CAAA;EACA,iBAAA;AApEN;;AAyEA;EACE,kBAAA;AAtEF;AAwEE;EACE,uBAAA;EACA,gBAAA;EACA,qCAAA;AAtEJ;AAwEI;EACE,mBAAA;EACA,4BAAA;AAtEN","sourcesContent":[".backend-manager-container {\n  padding: 1rem;\n  height: calc(100% - 32px);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 200px;\n  gap: 1rem;\n  color: var(--text-secondary);\n}\n\n.error-message {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 1rem;\n  background: var(--error-bg, rgba(244, 67, 54, 0.1));\n  border-radius: 8px;\n  color: var(--error-color, #f44336);\n  margin-bottom: 1rem;\n\n  mat-icon {\n    flex-shrink: 0;\n  }\n\n  span {\n    flex: 1;\n  }\n}\n\nh2 {\n  margin: 0 0 0.5rem 0;\n  font-size: 1.25rem;\n  font-weight: 500;\n}\n\n.subtitle {\n  color: var(--text-secondary);\n  margin: 0 0 1.5rem 0;\n}\n\n// Shared scrollable content mixin\n@mixin scrollable-content {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  // Use standard scrollbar styling that works across themes\n  scrollbar-width: thin;\n  scrollbar-color: rgba(155, 155, 155, 0.7) transparent;\n\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n    border-radius: 4px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(155, 155, 155, 0.7);\n    border-radius: 4px;\n\n    &:hover {\n      background: rgba(175, 175, 175, 0.9);\n    }\n  }\n}\n\n// Backend List\n.backend-list {\n  @include scrollable-content;\n\n  .backend-cards {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    padding-bottom: 1rem;\n  }\n}\n\n.backend-card {\n  background: var(--card-bg);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  padding: 1rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n\n  &:hover {\n    border-color: var(--accent-color);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  }\n\n  &.configured {\n    border-left: 3px solid var(--success-color, #4caf50);\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n\n  .backend-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 0.5rem;\n  }\n\n  .backend-name {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    font-weight: 500;\n    font-size: 1rem;\n\n    mat-icon {\n      color: var(--accent-color);\n    }\n  }\n\n  .status-badge {\n    font-size: 0.75rem;\n    padding: 0.25rem 0.5rem;\n    border-radius: 4px;\n\n    &.status-ready {\n      background: var(--success-bg, rgba(76, 175, 80, 0.1));\n      color: var(--success-color, #4caf50);\n    }\n\n    &.status-not-configured {\n      background: var(--neutral-bg, rgba(158, 158, 158, 0.1));\n      color: var(--text-secondary);\n    }\n  }\n\n  .backend-description {\n    color: var(--text-secondary);\n    font-size: 0.875rem;\n    margin: 0 0 1rem 0;\n    line-height: 1.4;\n  }\n\n  .backend-footer {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n\n    .model-count {\n      font-size: 0.75rem;\n      color: var(--text-secondary);\n      margin-right: auto;\n    }\n\n    // View/Configure button - use neutral colors for dark mode compatibility\n    .view-button {\n      color: var(--text-primary);\n      border-color: var(--border-color);\n      background: transparent;\n\n      &:hover {\n        background: var(--hover-bg, rgba(128, 128, 128, 0.1));\n        border-color: var(--text-secondary);\n      }\n    }\n  }\n}\n\n// Configure View\n.configure-view {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow: hidden;\n\n  .configure-header {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding-bottom: 0.5rem;\n    border-bottom: 1px solid var(--border-color);\n    margin-bottom: 1rem;\n    flex-shrink: 0;\n\n    h2 {\n      margin: 0;\n    }\n  }\n\n  .configure-content {\n    @include scrollable-content;\n    padding-bottom: 1rem;\n  }\n\n  .backend-description {\n    color: var(--text-secondary);\n    margin-bottom: 1.5rem;\n  }\n}\n\n.status-section {\n  background: var(--card-bg);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  padding: 1rem;\n  margin-bottom: 1.5rem;\n\n  h3 {\n    margin: 0 0 1rem 0;\n    font-size: 1rem;\n    font-weight: 500;\n  }\n\n  .status-row {\n    display: flex;\n    gap: 0.5rem;\n    margin-bottom: 0.5rem;\n    font-size: 0.875rem;\n\n    .status-label {\n      color: var(--text-secondary);\n      min-width: 120px;\n    }\n\n    .status-loading-value {\n      color: var(--text-secondary);\n      font-style: italic;\n    }\n\n    .status-ok {\n      color: var(--success-color, #4caf50);\n    }\n\n    .status-warning {\n      color: var(--warning-color, #ff9800);\n    }\n  }\n\n  button {\n    margin-top: 1rem;\n  }\n}\n\n.config-section {\n  background: var(--card-bg);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  padding: 1rem;\n  margin-bottom: 1.5rem;\n\n  h3 {\n    margin: 0 0 0.5rem 0;\n    font-size: 1rem;\n    font-weight: 500;\n  }\n\n  p {\n    color: var(--text-secondary);\n    font-size: 0.875rem;\n    margin: 0 0 1rem 0;\n  }\n\n  .full-width {\n    width: 100%;\n    margin-bottom: 1rem;\n  }\n\n  .get-key-button {\n    margin-bottom: 1rem;\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n      margin-right: 0.5rem;\n    }\n  }\n}\n\n.cli-instructions {\n  .cli-buttons {\n    display: flex;\n    gap: 0.75rem;\n    margin-top: 1rem;\n    flex-wrap: wrap;\n\n    button mat-icon {\n      margin-right: 0.5rem;\n    }\n  }\n}\n\n.cli-output {\n  background: var(--code-bg, #1e1e1e);\n  border-radius: 8px;\n  padding: 1rem;\n  overflow-x: auto;\n\n  pre {\n    margin: 0;\n    font-family: 'Fira Code', 'Consolas', monospace;\n    font-size: 0.8rem;\n    line-height: 1.5;\n    color: var(--code-text, #d4d4d4);\n    white-space: pre-wrap;\n    word-break: break-word;\n  }\n}\n\n.models-section {\n  background: var(--card-bg);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  padding: 1rem;\n\n  h3 {\n    margin: 0 0 0.5rem 0;\n    font-size: 1rem;\n    font-weight: 500;\n  }\n\n  .model-hint {\n    color: var(--text-secondary);\n    font-size: 0.875rem;\n    margin: 0 0 1rem 0;\n  }\n\n  .full-width {\n    width: 100%;\n    margin-bottom: 0.5rem;\n  }\n\n  .save-model-button {\n    margin-top: 0.5rem;\n  }\n\n  .model-chips {\n    mat-chip {\n      font-size: 0.75rem;\n    }\n  }\n}\n\n// Button with spinner\nbutton {\n  mat-spinner {\n    display: inline-block;\n    margin-right: 0.5rem;\n  }\n}\n\n// Claude Auth Wizard Styles\n.auth-loading {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem;\n  color: var(--text-secondary);\n\n  mat-spinner {\n    flex-shrink: 0;\n  }\n}\n\n.auth-prompt {\n  .auth-description {\n    color: var(--text-secondary);\n    margin-bottom: 1rem;\n    line-height: 1.5;\n  }\n\n  .auth-error {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.75rem 1rem;\n    background: var(--error-bg, rgba(244, 67, 54, 0.1));\n    border-radius: 8px;\n    color: var(--error-color, #f44336);\n    margin-bottom: 1rem;\n    font-size: 0.875rem;\n\n    mat-icon {\n      flex-shrink: 0;\n      font-size: 20px;\n      width: 20px;\n      height: 20px;\n    }\n  }\n\n  .auth-button {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.75rem 1.5rem;\n    font-size: 1rem;\n\n    mat-icon {\n      font-size: 20px;\n      width: 20px;\n      height: 20px;\n    }\n  }\n\n  .auth-note {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    margin-top: 1rem;\n    color: var(--text-secondary);\n    font-size: 0.8rem;\n\n    mat-icon {\n      font-size: 16px;\n      width: 16px;\n      height: 16px;\n      opacity: 0.7;\n    }\n  }\n}\n\n.auth-progress {\n  .auth-starting {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 2rem 1rem;\n    text-align: center;\n\n    .auth-status-text {\n      margin: 1rem 0 0.5rem;\n      font-size: 1rem;\n      color: var(--text-primary);\n    }\n  }\n\n  .auth-waiting {\n    padding: 1rem 0;\n\n    .auth-instructions {\n      display: flex;\n      align-items: center;\n      gap: 0.75rem;\n      margin: 0 0 0.75rem 0;\n      font-size: 0.9rem;\n      color: var(--text-primary);\n\n      mat-icon {\n        font-size: 20px;\n        width: 20px;\n        height: 20px;\n        color: var(--success-color, #4caf50);\n      }\n    }\n\n    .auth-code-field {\n      margin-top: 1rem;\n    }\n\n    .auth-error {\n      display: flex;\n      align-items: center;\n      gap: 0.5rem;\n      padding: 0.75rem 1rem;\n      background: var(--error-bg, rgba(244, 67, 54, 0.1));\n      border-radius: 8px;\n      color: var(--error-color, #f44336);\n      margin-bottom: 1rem;\n      font-size: 0.875rem;\n\n      mat-icon {\n        flex-shrink: 0;\n        font-size: 20px;\n        width: 20px;\n        height: 20px;\n      }\n    }\n\n    .auth-actions {\n      display: flex;\n      gap: 0.75rem;\n      margin-top: 1rem;\n\n      button mat-spinner {\n        margin-right: 0.5rem;\n      }\n    }\n  }\n}\n\n.auth-success {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem;\n  background: var(--success-bg, rgba(76, 175, 80, 0.1));\n  border-radius: 8px;\n  color: var(--success-color, #4caf50);\n  margin-bottom: 1rem;\n\n  .success-icon {\n    font-size: 24px;\n    width: 24px;\n    height: 24px;\n  }\n}\n\n.auth-expired {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem;\n  background: var(--error-bg, rgba(244, 67, 54, 0.1));\n  border-radius: 8px;\n  color: var(--error-color, #f44336);\n  margin-bottom: 1rem;\n\n  .expired-icon {\n    font-size: 24px;\n    width: 24px;\n    height: 24px;\n  }\n}\n\n.token-details {\n  background: var(--card-bg);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  padding: 0.75rem 1rem;\n  margin-bottom: 1rem;\n  font-size: 0.8rem;\n\n  .token-detail-row {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    margin-bottom: 0.5rem;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    .detail-label {\n      color: var(--text-secondary);\n      min-width: 60px;\n    }\n\n    .detail-value {\n      color: var(--text-primary);\n\n      &.expiring-soon {\n        color: var(--warning-color, #ff9800);\n      }\n\n      &.scopes {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 0.25rem;\n      }\n    }\n\n    .scope-chip {\n      background: var(--neutral-bg, rgba(128, 128, 128, 0.15));\n      padding: 0.15rem 0.5rem;\n      border-radius: 4px;\n      font-family: 'Fira Code', 'Consolas', monospace;\n      font-size: 0.7rem;\n    }\n  }\n}\n\n.advanced-option {\n  margin-top: 1.5rem;\n\n  mat-expansion-panel {\n    background: transparent;\n    box-shadow: none;\n    border: 1px solid var(--border-color);\n\n    mat-expansion-panel-header {\n      font-size: 0.875rem;\n      color: var(--text-secondary);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
